/* unplugin-vue-components disabled */import { render } from "./LogicalReasoning2DRender.vue?vue&type=template&id=057f164b&scoped=true"
import script from "./LogicalReasoning2DRender.vue?vue&type=script&lang=js"
export * from "./LogicalReasoning2DRender.vue?vue&type=script&lang=js"

import "./LogicalReasoning2DRender.vue?vue&type=style&index=0&id=057f164b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-057f164b"]])

export default __exports__